import { createFileRoute } from "@tanstack/react-router";
import type { QuickRigId } from "@brewbase/db/types";
import { RigDashboard } from "@/features/devices/RigDashboard";

export const Route = createFileRoute("/devices/rigs/$rigId")({
  component: RigRoute,
});

function RigRoute() {
  const { rigId } = Route.useParams();
  return <RigDashboard rigId={Number(rigId) as QuickRigId} />;
}
